import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import DividerBody from './DividerBody';

const View = (props) => <DividerBody {...props} />;

export default withBlockExtensions(View);
